import { useEffect } from 'react'

const META_PIXEL_ID = '2724560677910571'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let pixelInitialized = false

function initPixel() {
  if (typeof window === 'undefined' || pixelInitialized) return
  pixelInitialized = true

  // Initialize fbq function before script loads
  const w = window as any
  if (!w.fbq) {
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    w.fbq = n
    w._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
  }

  // Inject the script into head
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Inject noscript fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.head.appendChild(noscript)

  // Init and fire PageView
  window.fbq('init', META_PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackMetaEvent(
  eventName: string,
  params?: Record<string, any>,
) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params)
  }
}

export function useMetaPixel() {
  useEffect(() => {
    initPixel()
  }, [])

  return { trackMetaEvent }
}
